/*
  Rollbar is attached to the window via separate script tag (served to document by rails).
  The import is used to get the TS type, and so the package can remain a dev dependency.
*/
/* eslint-disable import/no-extraneous-dependencies */
import type Rollbar from 'rollbar'

const dispatchRollbarError = (...args: Rollbar.LogArgument[]) => {
  // @ts-ignore -- window global not typed yet
  const instance: Rollbar | undefined = window?.Rollbar

  if (!instance) return

  instance.error(...args)
}

export { dispatchRollbarError }
